import { AlertComponent } from './alert/alert.component';
import { CurrencyValueComponent } from './display-value/currency-value/currency-value.component';
import { CommonModule } from '@angular/common';
import { DialogComponent } from './dialog/dialog.component';
import { DateValueComponent } from './display-value/date-value/date-value.component';
import { ErrorNotificationService } from './error-notification.service';
import { ErrorPopUpComponent } from './error-pop-up/error-pop-up.component';
import { ErrorAlertComponent } from './error-alert/error-alert.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { faChevronLeft, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome'
import { FormattedValueComponent } from './display-value/formatted-value/formatted-value.component';
import { InlineHeaderComponent } from './inline-header/inline-header.component';
import { LoadingService } from './loading.service';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NumberValueComponent } from './display-value/number-value/number-value.component';
import { NgModule } from '@angular/core';
import { NgxMaskModule } from 'ngx-mask';
import { NoChangesComponent } from './no-changes/no-changes.component';
import { NgxFileDropModule } from 'ngx-file-drop';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { PhoneValueComponent } from './display-value/phone-value/phone-value.component';
import { PlainChipComponent } from './display-value/plain-chip/plain-chip.component';
import { FormActionsComponent } from './forms/form-actions/form-actions.component';
import { StepProcessButtonsComponent } from './step-process-buttons/step-process-buttons.component';
import { TimeValueComponent } from './display-value/time-value/time-value.component';
import { RouterModule } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTableModule } from '@angular/material/table';
import { MatRadioModule } from '@angular/material/radio';
import { FullPageSpinnerComponent } from './full-page-spinner/full-page-spinner.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatChipsModule } from '@angular/material/chips';
import { MaterialModules } from '../app/material.bundle';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';

@NgModule({
  declarations: [
    AlertComponent,
    FormattedValueComponent,
    CurrencyValueComponent,
    DateValueComponent,
    DialogComponent,
    ErrorAlertComponent,
    ErrorPopUpComponent,
    FileUploadComponent,
    FormActionsComponent,
    FullPageSpinnerComponent,
    InlineHeaderComponent,
    NoChangesComponent,
    NumberValueComponent,
    PageNotFoundComponent,
    PhoneValueComponent,
    PlainChipComponent,
    FormActionsComponent,
    StepProcessButtonsComponent,
    TimeValueComponent,
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule, 
    MatDatepickerModule,
    MatDialogModule,
    ...MaterialModules,
    MatFormFieldModule,
    MatNativeDateModule,
    MatTooltipModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatSnackBarModule,    
    MatStepperModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatRadioModule,
    MatChipsModule,
    RouterModule,
    NgxFileDropModule,
    NgxMaskModule,
    ReactiveFormsModule,
    NgxMaskModule
  ],
  providers: [
    ErrorNotificationService,
    LoadingService,
   { provide: STEPPER_GLOBAL_OPTIONS,   useValue: { showError: true, displayDefaultIndicatorType: false }}
  ],
  exports: [
    AlertComponent,
    DialogComponent,
    ErrorAlertComponent,
    ErrorPopUpComponent,
    FormattedValueComponent,
    FileUploadComponent,
    FormActionsComponent,
    FullPageSpinnerComponent,
    StepProcessButtonsComponent,
    InlineHeaderComponent,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatSnackBarModule,
    MatStepperModule,
    MatTooltipModule,
    NoChangesComponent,
    PageNotFoundComponent,
    PlainChipComponent,
    MatProgressSpinnerModule,
    MatTableModule,
    MatRadioModule,
    MatChipsModule,
    NgxMaskModule
  ]
})
export class SharedModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(faChevronLeft, faExclamationCircle)
  }
}

